// Device/share capability detection for the result actions. Pure functions so
// they can be unit-tested without instantiating the Custom Element.

export function canShareFiles(file: File) {
  // A present canShare implies a present share; guarding it directly avoids the
  // lib.dom "share is always defined" narrowing while still handling browsers
  // (desktop Firefox, older Safari) that expose neither.
  const nav = navigator as Navigator & { canShare?: (data?: ShareData) => boolean }
  return Boolean(nav.canShare?.({ files: [ file ] }))
}

// A deliberate cancel from the native share sheet (vs. a genuine failure we should
// recover from). Browsers signal cancel with a DOMException named "AbortError".
export function isAbort(error: unknown) {
  return error instanceof Error && error.name === "AbortError"
}

// iOS/iPadOS detection. iPadOS 13+ masquerades as "MacIntel", so also treat a
// touch-capable Mac as iOS for the <a download> workaround.
export function isIOS() {
  const nav = navigator as Navigator & { platform?: string; maxTouchPoints?: number }
  return /iPad|iPhone|iPod/.test(nav.userAgent) ||
    (nav.platform === "MacIntel" && (nav.maxTouchPoints ?? 0) > 1)
}
